import MAIPHeader from './MAIPHeader';

export default MAIPHeader;
